var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import styles from './sds-sidebar-section.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-sidebar-section` represents a collapsible section within a sidebar, optionally containing an icon, title,
 * and additional information. The component allows configuration for expanded or compact display.
 *
 * ### Attributes
 * - `sectionTitle`: Title text displayed in the sidebar section.
 * - `icon`: Icon associated with the section, enhancing visual context.
 * - `info`: Additional information or metadata related to the section.
 * - `toggle`: Controls the expanded or collapsed state of the section.
 * - `compact`: Enables a more compact display mode for the section content.
 *
 * @tag sds-sidebar-section
 */
let SdsSidebarSection = (() => {
    var _SdsSidebarSection_sectionTitle_accessor_storage, _SdsSidebarSection_icon_accessor_storage, _SdsSidebarSection_info_accessor_storage, _SdsSidebarSection_toggle_accessor_storage, _SdsSidebarSection_compact_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-sidebar-section')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _sectionTitle_decorators;
    let _sectionTitle_initializers = [];
    let _sectionTitle_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _info_decorators;
    let _info_initializers = [];
    let _info_extraInitializers = [];
    let _toggle_decorators;
    let _toggle_initializers = [];
    let _toggle_extraInitializers = [];
    let _compact_decorators;
    let _compact_initializers = [];
    let _compact_extraInitializers = [];
    var SdsSidebarSection = _classThis = class extends _classSuper {
        /**
         * Title text displayed for this sidebar section.
         *
         * @attr {string} section-title - Title of the sidebar section.
         */
        get sectionTitle() { return __classPrivateFieldGet(this, _SdsSidebarSection_sectionTitle_accessor_storage, "f"); }
        set sectionTitle(value) { __classPrivateFieldSet(this, _SdsSidebarSection_sectionTitle_accessor_storage, value, "f"); }
        /**
         * Icon associated with this sidebar section.
         *
         * @attr {string} icon - Icon name or URL displayed in the sidebar section.
         */
        get icon() { return __classPrivateFieldGet(this, _SdsSidebarSection_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsSidebarSection_icon_accessor_storage, value, "f"); }
        /**
         * Additional information related to the section.
         *
         * @attr {string} info - Supplementary information for the section.
         */
        get info() { return __classPrivateFieldGet(this, _SdsSidebarSection_info_accessor_storage, "f"); }
        set info(value) { __classPrivateFieldSet(this, _SdsSidebarSection_info_accessor_storage, value, "f"); }
        /**
         * Controls whether the section is expanded or collapsed. Possible values:
         * - `'expanded'`: The section is visible and expanded.
         * - `'collapsed'`: The section is hidden and collapsed.
         *
         * Defaults to 'expanded'.
         *
         * @attr {string} toggle - The toggle state of the sidebar section. Defaults to 'expanded'.
         */
        get toggle() { return __classPrivateFieldGet(this, _SdsSidebarSection_toggle_accessor_storage, "f"); }
        set toggle(value) { __classPrivateFieldSet(this, _SdsSidebarSection_toggle_accessor_storage, value, "f"); }
        /**
         * Enables a compact display mode for the section.
         *
         * @attr {boolean} compact - If true, displays the section in a compact mode.
         */
        get compact() { return __classPrivateFieldGet(this, _SdsSidebarSection_compact_accessor_storage, "f"); }
        set compact(value) { __classPrivateFieldSet(this, _SdsSidebarSection_compact_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-sidebar-section">
                ${this.renderSectionHeader()} ${this.renderSectionContent()}
            </div>
        `;
        }
        renderSectionHeader() {
            if (this.sectionTitle !== '' && this.sectionTitle !== undefined) {
                return html `
                <div class="sds-sidebar-section__header">
                    ${this.renderHeaderAction()} ${this.renderSectionIcon()}
                    ${this.renderSectionTitle()} ${this.renderInfoTooltip()}
                </div>
            `;
            }
        }
        renderSectionContent() {
            if (this.toggle === 'expanded') {
                return html `
                <div
                    class="sds-sidebar-section__content ${this.compact
                    ? 'sds-sidebar-section__content--compact'
                    : ''}"
                >
                    <slot></slot>
                </div>
            `;
            }
        }
        renderHeaderAction() {
            return html `
            <sds-button
                @click="${() => this.handleClick()}"
                icon="${this.toggle === 'collapsed' ? 'arrow_right_thin' : 'arrow_down_thin'}"
                type="secondary"
                size="md"
            ></sds-button>
        `;
        }
        renderInfoTooltip() {
            if (this.info !== '' && this.info !== undefined) {
                return html `
                <sds-tooltip basic position="up">
                    <sds-icon
                        class="sds-sidebar-section__info"
                        slot="trigger"
                        size="16"
                        name="information"
                    ></sds-icon>
                    <div slot="text">${this.info}</div>
                </sds-tooltip>
            `;
            }
        }
        renderSectionIcon() {
            if (this.icon !== '' && this.icon !== undefined) {
                return html ` <sds-icon size="24" name="${this.icon}"></sds-icon> `;
            }
        }
        renderSectionTitle() {
            if (this.sectionTitle !== '' && this.sectionTitle !== undefined) {
                return html ` <div class="sds-sidebar-section__title">${this.sectionTitle}</div>`;
            }
        }
        handleClick() {
            this.toggle = this.toggle === 'expanded' ? 'collapsed' : 'expanded';
            this.dispatchEvent(new CustomEvent(SdsSidebarSection.TOGGLE_EVENT, {
                detail: {
                    toggle: this.toggle,
                },
                bubbles: false,
                composed: false,
            }));
        }
        constructor() {
            super(...arguments);
            _SdsSidebarSection_sectionTitle_accessor_storage.set(this, __runInitializers(this, _sectionTitle_initializers, undefined));
            _SdsSidebarSection_icon_accessor_storage.set(this, (__runInitializers(this, _sectionTitle_extraInitializers), __runInitializers(this, _icon_initializers, undefined)));
            _SdsSidebarSection_info_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _info_initializers, undefined)));
            _SdsSidebarSection_toggle_accessor_storage.set(this, (__runInitializers(this, _info_extraInitializers), __runInitializers(this, _toggle_initializers, 'expanded')));
            _SdsSidebarSection_compact_accessor_storage.set(this, (__runInitializers(this, _toggle_extraInitializers), __runInitializers(this, _compact_initializers, void 0)));
            __runInitializers(this, _compact_extraInitializers);
        }
    };
    _SdsSidebarSection_sectionTitle_accessor_storage = new WeakMap();
    _SdsSidebarSection_icon_accessor_storage = new WeakMap();
    _SdsSidebarSection_info_accessor_storage = new WeakMap();
    _SdsSidebarSection_toggle_accessor_storage = new WeakMap();
    _SdsSidebarSection_compact_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSidebarSection");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _sectionTitle_decorators = [property({ type: String, attribute: 'section-title' })];
        _icon_decorators = [property({ type: String })];
        _info_decorators = [property({ type: String })];
        _toggle_decorators = [property({ type: String, reflect: true })];
        _compact_decorators = [property({ type: Boolean })];
        __esDecorate(_classThis, null, _sectionTitle_decorators, { kind: "accessor", name: "sectionTitle", static: false, private: false, access: { has: obj => "sectionTitle" in obj, get: obj => obj.sectionTitle, set: (obj, value) => { obj.sectionTitle = value; } }, metadata: _metadata }, _sectionTitle_initializers, _sectionTitle_extraInitializers);
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _info_decorators, { kind: "accessor", name: "info", static: false, private: false, access: { has: obj => "info" in obj, get: obj => obj.info, set: (obj, value) => { obj.info = value; } }, metadata: _metadata }, _info_initializers, _info_extraInitializers);
        __esDecorate(_classThis, null, _toggle_decorators, { kind: "accessor", name: "toggle", static: false, private: false, access: { has: obj => "toggle" in obj, get: obj => obj.toggle, set: (obj, value) => { obj.toggle = value; } }, metadata: _metadata }, _toggle_initializers, _toggle_extraInitializers);
        __esDecorate(_classThis, null, _compact_decorators, { kind: "accessor", name: "compact", static: false, private: false, access: { has: obj => "compact" in obj, get: obj => obj.compact, set: (obj, value) => { obj.compact = value; } }, metadata: _metadata }, _compact_initializers, _compact_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSidebarSection = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.TOGGLE_EVENT = 'sds.sidebar-section.toggle';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSidebarSection = _classThis;
})();
export { SdsSidebarSection };
